import {Icon} from '@wandb/components';
import clsx from 'clsx';
import React from 'react';
// TODO: Remove when @wandb/components has a ColorPicker component we can use
//       here. But until then, we need to use the bare Button to get the style
//       control needed for the color picker trigger.
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from 'react-aria-components';

import ColorPicker from '../../ColorPicker';
import {useWorkspaceSettingsColorPalette} from '../../WorkspaceDrawer/Settings/colorPalette/ColorPalette';

type RowColorPickerTriggerProps = {
  activeColor: string;
  onBlur: () => void;
  onClick: () => void;
  onFocus: () => void;
  onMouseLeave: () => void;
  onMouseEnter: () => void;
};

function RowColorPickerTrigger({
  activeColor,
  ...handlers
}: RowColorPickerTriggerProps) {
  // Need this to be a button for accessibility, and wandb/components doesn't
  // have an IconButton with custom coloring, yet. Note that when the run is
  // not baselined the icon is an XL circle, so the parent component normalizes
  // the difference in size between the two icons.

  const cls = clsx(
    'flex',
    'items-center',
    'justify-center',
    'cursor-pointer',
    'h-24',
    'w-24',
    'rounded-[var(--border-radius-sm)]',
    'outline-[var(--focus-ring-color)]',
    'focus:bg-moon-200',
    'hover:bg-moon-200'
  );

  return (
    <Button
      style={{color: activeColor}}
      aria-label="Change run color"
      className={cls}
      data-test="color-picker-trigger"
      {...handlers}>
      <span className="night-aware">
        <Icon icon="circle-filled" size="xl" __inverted />
      </span>
    </Button>
  );
}

type RowColorPickerProps = {
  customRunColor: string;
  isColorPickerVisible: boolean;
  onOpenColorPicker?: () => void;
  onSetCustomRunColor: (color: string) => void;
};

export function RowColorPicker({
  customRunColor,
  isColorPickerVisible,
  onSetCustomRunColor,
}: RowColorPickerProps) {
  const colorPaletteOption = useWorkspaceSettingsColorPalette();

  if (!isColorPickerVisible) {
    return null;
  }

  // TODO: migrate this to @wandb/components ColorPicker when it becomes available.
  //       JIRA: <https://wandb.atlassian.net/browse/WB-29706>
  return (
    <div className="flex shrink-0 items-center w-24 justify-center">
      <ColorPicker
        invertColorsInDarkMode={false}
        activeColor={customRunColor}
        setColor={onSetCustomRunColor}
        colorPaletteOption={colorPaletteOption}
        containerStyle={{left: '-10px'}}
        trigger={args => <RowColorPickerTrigger {...args} />}
      />
    </div>
  );
}
